<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>Shipping taking too long? We hear you.</v-card-title>
        <v-card-text>
          <p>We've added a new plan where you can keep a puzzle while sending two back!</p>
          <img
            class="product-image"
            src="https://completing-the-puzzle.s3.us-east-1.amazonaws.com/public/portal/blackbox2.png"
            alt="Pro Puzzler box with three puzzles"
          />
          <div class="offer-callout">
            <div class="offer-icon">
              <v-icon style="color: #2b2b2b; font-size: 22px;">mdi-puzzle</v-icon>
            </div>
            <div class="offer-body">
              <h3 class="offer-headline">"Always have a puzzle"</h3>
              <p class="offer-subtext">You always have 3 in rotation. We send you 2 puzzles, you keep 1 to solve and we send you 2 more!</p>
            </div>
          </div>

          <div class="billing-section">
            <p class="billing-heading">Choose your billing length</p>

            <div
              v-for="plan in plans"
              :key="plan.id"
              class="billing-option"
              :class="{ 'billing-option--selected': plan.id === selectedPlan }"
              @click="selectedPlan = plan.id"
            >
              <v-icon class="billing-option__radio" :color="plan.id === selectedPlan ? 'primary' : 'grey lighten-1'">
                {{ plan.id === selectedPlan ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
              </v-icon>
              <div class="billing-option__info">
                <div class="billing-option__label">
                  {{ plan.label }}
                  <span v-if="plan.badge" class="billing-badge" :class="plan.badgeClass">{{ plan.badge }}</span>
                </div>
                <div class="billing-option__billed">{{ plan.billed }}</div>
              </div>
              <div class="billing-option__price">
                <div class="billing-option__monthly">${{ plan.monthly }}<span class="billing-option__per">/mo</span></div>
                <div v-if="plan.save" class="billing-option__save">Save ${{ plan.save }}</div>
              </div>
            </div>

            <div class="billing-summary">
              <div class="billing-summary__row">
                <span>Pro Puzzler, {{ selectedPlanObj.label }}</span>
                <span>${{ selectedPlanObj.total }}</span>
              </div>
              <div class="billing-summary__row billing-summary__row--discount">
                <span>Upgrade discount: 20% off first month</span>
                <span class="billing-summary__discount">-${{ upgradeDiscount }}</span>
              </div>
              <div class="billing-summary__row billing-summary__row--total">
                <span>Today</span>
                <span>${{ todayTotal }}</span>
              </div>
              <p class="billing-summary__note">Then ${{ selectedPlanObj.monthly }} monthly. Pause or cancel anytime.</p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click="acceptOffer">Upgrade my Puzzling Experience</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" class="white--text" @click="continueToCancel">Continue to cancel</v-btn>
        </v-card-actions>
        <v-card-text v-if="error">
          <span class="error--text">{{error}}</span>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card>
        <v-card-title>You're all set!</v-card-title>
        <v-card-text>
          Thanks! Your upgrade request is received and will be manually processed by a support specialist. We'll be in touch shortly to confirm your new plan.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dismiss">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import subscriptionService from '../api/subscription-service';

export default {
  name: 'shipping_retention_offer',
  props: ['subscription_id'],
  data: function() {
    return {
      dialog: false,
      loading: false,
      error: null,
      selectedPlan: 'monthly',
      plans: [
        { id: 'monthly',  label: 'Monthly',  badge: null,            badgeClass: '',                       monthly: 46, total: 46,  billed: '$46 billed monthly',          save: 0,  planName: '2PUZZ1MONTHKEEPER2026' },
        { id: '3_months', label: '3 months', badge: 'Most popular',  badgeClass: 'billing-badge--popular', monthly: 45, total: 135, billed: '$135 billed every 3 months',  save: 3,  planName: '2PUZZ3MONTHKEEPER2026' },
        { id: '6_months', label: '6 months', badge: 'Best value',    badgeClass: 'billing-badge--value',   monthly: 44, total: 264, billed: '$264 billed every 6 months',  save: 12, planName: '2PUZZ6MONTHKEEPER2026' },
        { id: '1_year',   label: '1 year',   badge: null,            badgeClass: '',                       monthly: 43, total: 516, billed: '$516 billed every year',      save: 36, planName: '2PUZZ12MONTHKEEPER2026' }
      ]
    }
  },
  computed: {
    selectedPlanObj: function() {
      return this.plans.find((p) => p.id === this.selectedPlan) || this.plans[0];
    },
    upgradeDiscount: function() {
      return Math.round(this.selectedPlanObj.monthly * 0.2);
    },
    todayTotal: function() {
      return this.selectedPlanObj.total - this.upgradeDiscount;
    }
  },
  methods: {
    acceptOffer: function() {
      this.loading = true;
      this.error = null;
      subscriptionService.upgradePlan(
        this.subscription_id,
        this.selectedPlanObj.planName,
        () => {
          this.loading = false;
          this.dialog = true;
        },
        () => {
          this.loading = false;
          this.error = 'Something went wrong. Please try again.';
        }
      );
    },
    dismiss: function() {
      this.dialog = false;
      this.$router.push({ name: 'account', params: { subscription_id: this.subscription_id } });
    },
    continueToCancel: function() {
      this.$router.push({ name: 'cancel_details', params: { subscription_id: this.subscription_id }, query: { reason: 'want_faster_shipping' } });
    }
  }
}
</script>

<style scoped>
.product-image {
  display: block;
  max-width: 320px;
  width: 100%;
  height: auto;
  margin: 16px auto;
  border-radius: 12px;
}

.offer-callout {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background-color: #2b2b2b;
  border-radius: 12px;
  padding: 18px 20px;
  margin: 16px 0;
}

.offer-icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f2c94c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.offer-body {
  flex: 1 1 auto;
}

.offer-headline {
  margin: 0 0 6px;
  color: #f2c94c;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.offer-subtext {
  margin: 0;
  color: #d6d6d6;
  font-size: 14px;
  line-height: 1.5;
}

.billing-section {
  margin: 20px 0;
}

.billing-heading {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 12px;
  font-weight: 700;
  color: #6b6b6b;
  margin-bottom: 12px;
}

.billing-option {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.billing-option--selected {
  border-color: #1976d2;
  box-shadow: 0 0 0 1px #1976d2;
}

.billing-option__radio {
  flex: 0 0 auto;
}

.billing-option__info {
  flex: 1 1 auto;
}

.billing-option__label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #2b2b2b;
}

.billing-option__billed {
  font-size: 13px;
  color: #8a8a8a;
  margin-top: 2px;
}

.billing-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 10px;
}

.billing-badge--popular {
  background-color: #f2c94c;
  color: #2b2b2b;
}

.billing-badge--value {
  background-color: #27ae60;
  color: #ffffff;
}

.billing-option__price {
  flex: 0 0 auto;
  text-align: right;
}

.billing-option__monthly {
  font-size: 20px;
  font-weight: 700;
  color: #2b2b2b;
}

.billing-option__per {
  font-size: 12px;
  font-weight: 400;
  color: #8a8a8a;
}

.billing-option__save {
  font-size: 12px;
  font-weight: 700;
  color: #27ae60;
}

.billing-summary {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
}

.billing-summary__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #2b2b2b;
  margin-bottom: 8px;
}

.billing-summary__row--discount {
  color: #27ae60;
}

.billing-summary__discount {
  color: #27ae60;
  font-weight: 700;
}

.billing-summary__row--total {
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
  margin-top: 4px;
  margin-bottom: 4px;
  font-size: 18px;
  font-weight: 700;
}

.billing-summary__note {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8a8a8a;
}
</style>
